import { Link } from "react-router-dom";
import { Button, Flex, Typography } from "@payping/web-components";
import useTranslator from "@/shared/translate/translator";
import { Constants as routerConstants } from "@/refund/routes";

const Init: React.FC = () => {
  const { t } = useTranslator("refund.init");

  return (
    <Flex vertical justify="center" align="center" gap="large" className="tw-min-h-[226px]">
      <Typography.Title level={5} className="!tw-m-0">
        {t("title")}
      </Typography.Title>
      <Typography.Paragraph type="secondary" className="!tw-m-0">
        {t("paragraph")}
      </Typography.Paragraph>
      <Link to={routerConstants.contract.url}>
        <Button type="primary">{t("action")}</Button>
      </Link>
    </Flex>
  );
};
export default Init;
